import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const StyledSwitch = styled(Switch)({
  width: 80,
  height: 50,
  padding: 9,
  color: '#CCCCCC',
  fontSize: 12,
  '& .MuiSwitch-switchBase': {
    padding: 11,
    color: '#CCCCCC',
    '&.Mui-checked': {
      color: '#CCCCCC',
      transform: 'translateX(32px)',
      '&:hover': {
        backgroundColor: 'rgba(24,90,257,0.08)',
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: '#1C9CD5',
        '&:before': { opacity: 1 },
        '&:after': { opacity: 0 },
      },
      '& + .MuiSwitch-track': {
        background: 'linear-gradient(#CCCCCC, #CCCCCC)',
        '&:before': { opacity: 1 },
        '&:after': { opacity: 0 },
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 30,
    height: 30,
    backgroundColor: '#1C9CD5',
    '&:before, &:after': {
      display: 'inline-block',
      position: 'absolute',
      top: '50%',
      width: '90%',
      transform: 'translateY(-50%)',
      color: '#fff',
      textAlign: 'center',
      fontSize: 12,
    },
    '&:before': {
      content: '"On"',
      left: 2,
      opacity: 0,
    },
    '&:after': {
      content: '"Off"',
      right: 5,
    },
  },
  '& .MuiSwitch-track': {
    background: '#CCCCCC',
    opacity: '1 !important',
    borderRadius: 20,
    position: 'relative',
    '&:before, &:after': {
      display: 'inline-block',
      position: 'absolute',
      top: '50%',
      width: '50%',
      transform: 'translateY(-50%)',
      color: '#fff',
      textAlign: 'center',
    },
    '&:before': {
      content: '"Off"',
      left: 4,
      opacity: 0,
    },
    '&:after': {
      content: '"On"',
      right: 4,
    },
  },
});

export { StyledSwitch };
